import ViewsImpersonation from '@/views/impersonation/ViewsImpersonation.vue';

import {home} from '@/router/breadcrumbs';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/oobo',
        name: 'impersonation',
        component: ViewsImpersonation,
        meta: {
            requiresAuth: true,
            breadcrumbs: [home, {text: 'impersonation'}],
            permissions: [PERMISSIONS.IMPERSONATE_USER]
        }
    }
] as RouteRecordRaw[]